import { Editor } from "@tiptap/react";
import { ToolbarGroup } from "../components/Toolbar";

export const getToolbarGroups = (
  editor: Editor,
  setEditingLabel: React.Dispatch<React.SetStateAction<boolean>>,
  source: string
): ToolbarGroup[] => [
  {
    id: "section1",
    buttons: [
      {
        action: () => editor.chain().focus().toggleBold().run(),
        iconId: "editor.bold",
        activeCondition: "bold",
      },
      {
        action: () => editor.chain().focus().toggleItalic().run(),
        iconId: "editor.italic",
        activeCondition: "italic",
      },
      {
        action: () => editor.chain().focus().toggleUnderline().run(),
        iconId: "editor.underline",
        activeCondition: "underline",
      },
      {
        action: () => editor.chain().focus().toggleStrike().run(),
        iconId: "editor.strike",
        activeCondition: "strike",
      },
    ],
  },
  {
    id: "section2",
    buttons: [
      {
        action: () => editor.chain().focus().toggleBulletList().run(),
        iconId: "editor.unordered-list",
        activeCondition: "bulletList",
      },
      {
        action: () => editor.chain().focus().toggleOrderedList().run(),
        iconId: "editor.ordered-list",
        activeCondition: "orderedList",
      },
      {
        action: () => setEditingLabel(true),
        iconId: "editor.link",
        activeCondition: "link",
        popupSource: source,
      },
    ],
  },
  {
    id: "section3",
    buttons: [
      {
        action: () => editor.chain().focus().toggleCode().run(),
        iconId: "editor.code",
        activeCondition: "code",
      },
      {
        action: () => editor.chain().focus().setHorizontalRule().run(),
        iconId: "editor.line",
        activeCondition: "line",
      },
      {
        action: () => editor.chain().focus().toggleBlockquote().run(),
        iconId: "editor.quote",
        activeCondition: "blockquote",
      },
    ],
  },
];
